import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import webPortalsHero from "../assets/Hero/web-portal.jpg"; // Replace with your hero image
import webPortalsImage from "../assets/Hero/web-portal.webp"; // Replace with your web portals image
import "../assets/css/webPortalsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const webPortalsData = {
  hero: {
    title: "Web Portals",
    subtitle: "Empowering Your Business with Custom Web Portal Solutions",
  },
  introduction: {
    heading: "Why Web Portals Matter",
    paragraphs: [
      "Web portals provide a centralized platform for accessing information, services, and tools, enhancing user experience and operational efficiency.",
      "Our web portal solutions are designed to deliver seamless integration, intuitive navigation, and robust functionality for your business needs.",
    ],
  },
  cta: {
    heading: "Ready to Build Your Web Portal?",
    text: "Contact us today to learn more about our Web Portal Solutions and how we can help your business thrive.",
  },
};

export const WebPortalsPage = ({ data }) => {
  const webPortalsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = webPortalsRef.current.querySelectorAll(".web-portals-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: webPortalsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="web-portals-page" ref={webPortalsRef}>
      {/* Hero Section */}
      <div
        className="web-portals-hero-section"
        style={{ backgroundImage: `url(${webPortalsHero})` }}
      >
        <h1 className="web-portals-animate">{webPortalsData.hero.title}</h1>
        <p className="web-portals-animate">{webPortalsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container web-portals-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="web-portals-animate">{webPortalsData.introduction.heading}</h2>
            {webPortalsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="web-portals-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 web-portals-image-container">
            <img
              src={webPortalsImage}
              className="img-fluid web-portals-animate"
              alt="Web Portals"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container web-portals-cta">
        <h2 className="web-portals-animate">{webPortalsData.cta.heading}</h2>
        <p className="web-portals-animate">{webPortalsData.cta.text}</p>
        <button
          className="btn btn-primary web-portals-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};